import IdentityTagSelection from './IdentityTagSelection';

export default IdentityTagSelection;
